var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card pb-3 mb-0" }, [
    _c("div", { staticClass: "card-content" }, [
      _c("div", { staticClass: "shadow" }, [
        _c(
          "a",
          {
            attrs: {
              href: "/member/" + _vm.supplier.type + "/" + _vm.supplier.slug,
            },
          },
          [
            _c("img", {
              staticClass: "img-fluid card-img-top",
              staticStyle: { "object-fit": "cover" },
              attrs: {
                src:
                  _vm.supplier.cover == null
                    ? "/images/cover.jpg"
                    : _vm.supplier.cover.url,
                alt: "Cover image",
              },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex" }, [
        _c("div", { staticClass: "text-center" }, [
          _c(
            "div",
            {
              staticClass: "avatar avatar-lg",
              staticStyle: { "margin-top": "-20px" },
            },
            [
              _c(
                "a",
                {
                  attrs: {
                    href:
                      "/member/" + _vm.supplier.type + "/" + _vm.supplier.slug,
                  },
                },
                [
                  _c("img", {
                    staticClass: "rounded-circle shadow",
                    attrs: {
                      src:
                        _vm.supplier.avatar == null
                          ? "/images/avatar.png"
                          : _vm.supplier.avatar.url,
                      alt: "Avatar image",
                    },
                  }),
                ]
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pt-05 pr-05" }, [
          _c(
            "a",
            {
              attrs: {
                href: "/member/" + _vm.supplier.type + "/" + _vm.supplier.slug,
              },
            },
            [
              _c("h6", { staticClass: "mb-0 text-bold-700" }, [
                _vm._v(_vm._s(_vm.supplier.title)),
              ]),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.supplier.disabled === 1
        ? _c("div", { staticClass: "p-2" }, [
            _c(
              "span",
              {
                staticClass:
                  "badge badge-pill bg-danger mb-05 text-bold-700 font-small-2 ",
              },
              [
                _c("i", { staticClass: "feather icon-alert-circle" }),
                _vm._v(
                  " " +
                    _vm._s(_vm.__("resource.page_inactive")) +
                    "\n                "
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.service_settings.description_display
        ? _c("div", {
            staticClass:
              "card-content supplier-description font-small-4 mt-1 mx-1",
            domProps: { innerHTML: _vm._s(_vm.description) },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "card-bottom p-05  d-flex font-small-3 align-items-center justify-content-between ",
        },
        [
          _vm.supplier.privacy === "1"
            ? _c(
                "span",
                {
                  staticClass:
                    " badge-sm badge-pill badge-light text-white font-small-1 ",
                  staticStyle: { padding: "0.3rem 0.5rem" },
                },
                [
                  _c("i", {
                    staticClass: "fa fa-shield-alt",
                    attrs: {
                      "data-toggle": "tooltip",
                      "data-placement": "bottom",
                      title: "Private Page",
                    },
                  }),
                  _vm._v(
                    "  " +
                      _vm._s(_vm.__("globals.private")) +
                      "\n                "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("join-service", {
            staticClass: "ml-auto",
            attrs: {
              type: "supplier",
              slug: _vm.supplier.slug,
              status: _vm.supplier.is_following,
              button_size: "small",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }